import { render } from "./BookingTable.vue?vue&type=template&id=5bc304f6&scoped=true"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"

import "./BookingTable.vue?vue&type=style&index=0&id=5bc304f6&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc304f6"]])

export default __exports__